import { logUnifiedTelemetry } from "owa-analytics";
import { scrubForPii } from "owa-config";

import type { UnifiedEvent } from "owa-analytics-types";

/**
 * Unified Telemetry supported events for places
 */
export type PlacesSupportedEventName = "PlacesSetWorkPlan" | "PlacesViewAdminPortal" | "PlacesAppLoad" | "PlacesWelcomeShown" | "PlacesViewConnections" | "PlacesConnectionsEdited" | "PlacesSetWorkRoutine" | "PlacesAdminAction" | "PlacesSetDayForAgendaView" | "PlacesComponentViewChange" | "PlacesNavigationClick" | "PlacesOpenPlacesFinder" | "QuickBookModalAction" | "QuickBookLoadedInPeek" | "DeskBookLoadedInPeek" | "MapInteraction" | "PlacesUserSettings" | "PlacesWorkGuidanceInteraction" | "PlacesNoWorkDaysStateAction" | "PlacesExploreCollaboratorsView" | "PlacesPageLoad" | "PlacesExploreCardInteraction" | "PlacesPeopleInteraction" | "PlacesTimestripSelectDate" | "PlacesFinderFirstInteraction" | "PlacesClosePlacesFinder" | "PlacesBuildingNavigation" | "RoomFinderSelectPlace" | "OpenDeskReservationForm" | "QuickBookModalInteractionTime" | "QuickBookSuggestionInteraction" | "PlacesUserAction";

type SupportedPlacesUT = Extract<UnifiedEvent, {
    eventName: PlacesSupportedEventName;
}>;

/**
 * Logs Unified Telemetry event for places
 */
export default function logPlacesEvent(unifiedTelemetry: SupportedPlacesUT): void {
    // We have to check for ActionFailureInfo manually because it is not a part of some events args type
    if (unifiedTelemetry.data && "ActionFailureInfo" in unifiedTelemetry.data) {
        unifiedTelemetry.data.ActionFailureInfo = scrubForPii(JSON.stringify(unifiedTelemetry.data.ActionFailureInfo));
    }
    // Use `logUnifiedTelemetry()` to send only to Unified Telemetry.
    // Unlike `logUsage()`, it won’t also send data to other Aria tenants.
    logUnifiedTelemetry(unifiedTelemetry);
}
